import React from "react";
import { FaApple, FaRocket } from "react-icons/fa";
import { MdOutlineDesignServices } from "react-icons/md";
import { HiBolt } from "react-icons/hi2";
import "./IOSAppSection.css";

const IOSAppSection = () => {
  return (
    <>
      <section className="ios-dev-section">

        {/* Animated Background */}
        <div className="ios-bg-circle one"></div>
        <div className="ios-bg-circle two"></div>

        <div className="ios-container">

          {/* LEFT CONTENT */}
          <div className="ios-left">

            <span className="ios-badge">
              PREMIUM iOS APP DEVELOPMENT
            </span>

            <h2>
              Crafting Stunning
              <span> iPhone Experiences</span>
            </h2>

            <p>
              We build sleek, high-performance iOS applications
              with smooth animations, premium UI/UX and scalable
              architecture for startups & enterprises.
            </p>

            {/* Features */}
            <div className="ios-feature-grid">

              <div className="ios-feature-card">
                <div className="ios-icon">
                  <FaApple />
                </div>

                <h4>Native Swift Apps</h4>

                <p>
                  Fully optimized iOS applications built using Swift.
                </p>
              </div>

              <div className="ios-feature-card">
                <div className="ios-icon">
                  <HiBolt />
                </div>

                <h4>Ultra Smooth</h4>

                <p>
                  Blazing-fast performance with fluid interactions.
                </p>
              </div>

              <div className="ios-feature-card">
                <div className="ios-icon">
                  <MdOutlineDesignServices />
                </div>

                <h4>Premium UI/UX</h4>

                <p>
                  Elegant modern interfaces users instantly love.
                </p>
              </div>

              <div className="ios-feature-card">
                <div className="ios-icon">
                  <FaRocket />
                </div>

                <h4>App Store Launch</h4>

                <p>
                  Complete deployment support for App Store release.
                </p>
              </div>

            </div>

            {/* Buttons */}

          </div>

          {/* RIGHT SIDE */}
          <div className="ios-right">

            {/* Main Phone */}
            <div className="iphone-main">

              <div className="iphone-notch"></div>

              <div className="iphone-screen">

                <div className="screen-header">
                  <span>9:41</span>
                  <span>⚡ 100%</span>
                </div>

                <div className="music-card">
                  <div className="music-art"></div>

                  <h4>AppVerse Music</h4>
                  <p>Premium iOS Experience</p>

                  <div className="music-progress">
                    <div className="music-progress-fill"></div>
                  </div>

                  <div className="music-controls">
                    <span>⏮</span>
                    <span>▶</span>
                    <span>⏭</span>
                  </div>
                </div>

                {/* <div className="mini-stats">

                <div className="mini-card">
                  <h5>4.9★</h5>
                  <p>App Rating</p>
                </div>

                <div className="mini-card">
                  <h5>1M+</h5>
                  <p>Downloads</p>
                </div>

              </div> */}

              </div>

            </div>

            {/* Floating Cards */}
            <div className="floating-ui ui-one">
              <span>🔥</span>
              <p>Top Rated UI</p>
            </div>

            <div className="floating-ui ui-two">
              <span>⚡</span>
              <p>Fast Performance</p>
            </div>

            <div className="floating-ui ui-three">
              <span>🚀</span>
              <p>Launch Ready</p>
            </div>

          </div>

        </div>
        <style>{`
      
      .iphone-main{
  width: 320px;
  height: 650px;
  border-radius: 42px;
  padding: 10px;
  position: relative;

  background:
    linear-gradient(
      145deg,
      #2b2b2b,
      #0d0d0d
    );

  box-shadow:
    0 40px 80px rgba(0,0,0,.25),
    0 15px 35px rgba(255,50,80,.15),
    inset 0 1px 1px rgba(255,255,255,.08);

  border: 1px solid rgba(255,255,255,.08);
}.iphone-screen{
  height: 100%;
  border-radius: 34px;
  overflow: hidden;
  position: relative;

  background:
    radial-gradient(
      circle at top,
      rgba(255,55,95,.18),
      transparent 40%
    ),
    linear-gradient(
      180deg,
      #141414,
      #050505
    );
}.music-art{
  width: 140px;
  height: 140px;
  margin: auto;
  border-radius: 30px;

  background:
    linear-gradient(
      135deg,
      #ff4d67,
      #ff304f
    );

  transform: rotate(18deg);

  box-shadow:
    0 20px 40px rgba(255,70,100,.35);
}.floating-ui{
  background: rgba(255,255,255,.9);
  backdrop-filter: blur(20px);

  border: 1px solid rgba(255,255,255,.6);

  box-shadow:
    0 15px 40px rgba(0,0,0,.08);

  border-radius: 18px;

  padding: 14px 18px;
}.ios-right{
  position: relative;
}

.ios-right::before{
  content:'';
  position:absolute;

  width:520px;
  height:520px;

  background:
    radial-gradient(
      circle,
      rgba(255,60,80,.12),
      transparent 70%
    );

  top:50%;
  left:50%;

  transform:
    translate(-50%,-50%);

  z-index:-1;
}@keyframes floatY{
  0%,100%{
    transform:translateY(0);
  }

  50%{
    transform:translateY(-12px);
  }
}

.iphone-main{
  animation: floatY 6s ease-in-out infinite;
}

.ui-one{
  animation: floatY 4s ease-in-out infinite;
}

.ui-two{
  animation: floatY 5s ease-in-out infinite;
}
.screen-header span{
  font-weight:700;
  color:#fff !important;
}
.ui-three{
  animation: floatY 4.5s ease-in-out infinite;
}.iphone-notch{
  width: 120px;
  height: 34px;

  background:#000;

  border-radius:30px;

  position:absolute;
 top: 39px;
    left: 47%;

  transform:translateX(-50%);

  box-shadow:
    inset 0 2px 4px rgba(255,255,255,.05);
}
      
      
      .ios-icon{
    width:72px;
    height:72px;

    display:flex;
    align-items:center;
    justify-content:center;

  

    border-radius:22px;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    color:#fff;
    font-size:32px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:all .4s ease;
}

.ios-feature-card:hover .ios-icon{
    transform:
        translateY(-8px)
        rotate(-6deg)
        scale(1.08);

    box-shadow:
        0 25px 60px rgba(232,33,42,.35);
}`}</style>
      </section>
    </>
  );
};

export default IOSAppSection;